import { AlertState } from "global/AlertState";
import { LoginActiveView } from "global/LoginActiveView";
import { RoleState } from "global/RoleState";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { LoginState } from "../global/LoginState";
import { UserState } from "../global/UserState";
import sessionCheck from "./SessionCheck";

const TokenChecker = () => {
  const [, setLoginState] = useRecoilState(LoginState);
  const [, setAlertMessage] = useRecoilState(AlertState);
  const [, setUserState] = useRecoilState(UserState);
  const [role, setRoleState] = useRecoilState(RoleState);
  const setLoginView = useSetRecoilState(LoginActiveView);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [setLoginState, setRoleState]);

  const fetchData = async () => {
    var response = await sessionCheck(
      `/auth/data`,
      "GET",
      null,
      false,
      true,
      setAlertMessage,
      navigate,
      setLoginState,
    );
    if (response?.success) {
      var body = response?.body?.body;
      if (body?.hasPasswordChanged === false) {
        setLoginView("change-password");
        navigate("/change-password", { replace: true });
      } else {
        // callApi
        var userRole = body?.role;
        setRoleState(userRole);
        setLoginState(true);
        setUserState({
          username: body?.username,
          hasPasswordChanged: body?.hasPasswordChanged,
          // hasQuestionSaved: body?.hasQuestionsSaved,
        });
        if (userRole === "Admin" || userRole === "SuperAdmin")
          navigate("/exams");
        else if (userRole === "Examiner") navigate("/check");
        else if (userRole === "HeadExaminer") navigate("/examiners");
        else if (userRole === "SectionOfficer") navigate("/cs-listing");
      }
    }
  };

  return null;
};

export default TokenChecker;
